import { render, staticRenderFns } from "./UserTags.vue?vue&type=template&id=767b2f3a&scoped=true&"
import script from "./UserTags.vue?vue&type=script&lang=js&"
export * from "./UserTags.vue?vue&type=script&lang=js&"
import style0 from "./UserTags.vue?vue&type=style&index=0&id=767b2f3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b2f3a",
  null
  
)

export default component.exports